
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/asset/exchange",
      function () {
        return require("private-next-pages/asset/exchange.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/asset/exchange"])
      });
    }
  